import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'
import { buttonVariants } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'

const NewsSidebar = ({
  items,
  canManage,
}: {
  items: wowaudit.GlobalNewsItem[]
  canManage: boolean
}) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const defaultId = String(
    items.find((item) => item.published)?.id ?? items[0]?.id,
  )

  return (
    <nav className='flex flex-col gap-3 shrink-0 w-full lg:w-64 lg:border-r lg:border-border lg:pr-8'>
      {canManage && (
        <Link
          to='/news/new'
          className={buttonVariants({ variant: 'default', size: 'sm' })}
        >
          <Plus className='w-4 h-4 mr-2' />
          {t('news.new-post')}
        </Link>
      )}

      <div className='flex flex-col gap-0.5'>
        {items.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className={cn(
              'block rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent',
              String(item.id) === (id ?? defaultId) &&
                'bg-accent font-medium text-primary',
            )}
          >
            <div className='flex items-center justify-between gap-2'>
              <span
                className={cn(
                  'truncate',
                  !item.title && 'italic text-muted-foreground',
                )}
              >
                {item.title || t('news.no-title')}
              </span>
              {!item.published && (
                <Badge variant='outline' className='shrink-0'>
                  {t('news.draft')}
                </Badge>
              )}
            </div>
            {item.firstPublishedAt && (
              <div className='text-xs text-muted-foreground'>
                {dayjs(item.firstPublishedAt).format('MMM D, YYYY')}
              </div>
            )}
          </Link>
        ))}
      </div>
    </nav>
  )
}

export default NewsSidebar
